import Axios from 'axios';

export class AxiosApiService {
    constructor (baseUrl) {
        this.baseUrl = baseUrl;
    }

    get({
        path,
        urlParams,
        queryParams
    }) {
        return Axios.get(this.buildUrl({ path, urlParams, queryParams }));
    }

    post ({
        path,
        urlParams,
        queryParams,
        payload
    }) {
        return Axios.post(this.buildUrl({ path, urlParams, queryParams }), payload);
    }

    buildUrl ({
        path,
        urlParams,
        queryParams
    }) {
        let resource = this.injectUrlParams(path, urlParams);
        resource = this.injectQueryString(resource, queryParams);
        return `${this.baseUrl}${resource}`;
    }

    injectUrlParams (url, urlParams) {
        let resultUrl = url;
        if (urlParams && typeof(urlParams) === 'object') {
            Object.keys(urlParams)
                .forEach(paramName => {
                    resultUrl = resultUrl.replace(`:${paramName}`, urlParams[paramName])
                });
        }
        return resultUrl;
    }

    injectQueryString (url, queryParams) {
        let queryString = '';
        if (queryParams && typeof(queryParams) === 'object') {
            const params = []
            Object.keys(queryParams)
                .forEach(name => {
                    const value = queryParams[name];
                    if (value) {
                        params.push(`${name}=${value}`);
                    }
                });
            if (params.length) {
                queryString = `${url.includes('?') ? '&' : '?'}${params.join('&')}`;
            }
        }
        return `${url}${queryString}`;
    }
}